import {
  useGetUserClassroomManagements,
  useDeleteClassroomManagement,
  getGetUserClassroomManagementsQueryKey,
  useGetTopClassroomManagements,
  likeClassroomManagement,
  unlikeClassroomManagement,
  getGetTopClassroomManagementsQueryKey,
} from "@packages/api/madlenAPI";
import ClassroomManagementCard from "../../components/classroom-management/ClassroomManagementCard";
import GenericToolPage from "../../components/tool_components/GenericToolPage";
import { ClassroomManagementResponseDto } from "@packages/api/madlenAPI.schemas";

interface ExtendedClassroomManagementResponseDto
  extends ClassroomManagementResponseDto {
  isEditable?: boolean;
}

const ClassroomManagementDetailComponent = ({
  tool,
}: {
  tool: ExtendedClassroomManagementResponseDto;
}) => {
  return (
    <ClassroomManagementCard
      tools={tool}
      isEditable={tool.isEditable}
      onCreateAgain={undefined}
    />
  );
};

const ClassroomManagementsView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserClassroomManagements}
      useDeleteTool={useDeleteClassroomManagement}
      getGetToolsQueryKey={getGetUserClassroomManagementsQueryKey}
      useGetTopTools={useGetTopClassroomManagements}
      likeTool={likeClassroomManagement}
      unlikeTool={unlikeClassroomManagement}
      getGetTopToolsQueryKey={getGetTopClassroomManagementsQueryKey}
      toolType="classroomManagement"
      toolPath="classroom-management"
      DetailComponent={ClassroomManagementDetailComponent}
      colors={{
        light: "from-fuchsia-600 to-amber-600",
        dark: "dark:from-fuchsia-400 dark:to-amber-400",
        iconBg: "bg-fuchsia-100 dark:bg-fuchsia-900/50",
        iconColor: "text-fuchsia-600 dark:text-fuchsia-400",
        hover: "hover:bg-fuchsia-50 dark:hover:bg-fuchsia-900/20",
      }}
      toolColor="fuchsia"
      gradientColor="yellow"
    />
  );
};

export default ClassroomManagementsView;
